import { Component } from "@angular/core"
import { AuthService } from "src/app/services/auth.service"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-maintenance",
	templateUrl: "./maintenance.component.html",
	styleUrls: ["./maintenance.component.scss"]
})
export class MaintenanceComponent {
	public assets_version = environment.ASSETS_VERSION

	constructor(public authService: AuthService) {}
}
